module.exports = __webpack_public_path__ + "static/tanz_in_winterthur-a6cd795b843e8da470f9757f0e0ae178.jpg";